import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgWrinklesGlyphSecondary from './svgs/WrinklesGlyphSecondary.js';
import SvgWrinklesGlyph from './svgs/WrinklesGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var wrinklesGlyph = (props => useIcon(SvgWrinklesGlyph, SvgWrinklesGlyphSecondary, props));

export { wrinklesGlyph as default };
